module.exports = __webpack_public_path__ + "9edf45b70d8b738d885b3c434be85e28.svg";